import { getFactionWrestlerIds } from './factionWrestlers';

export const isWrestlerActive = (value) => {
  if (value === null || value === undefined || value === '') return true;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    return ['1', 'true', 'yes', 'si', 'y'].includes(value.trim().toLowerCase());
  }
  return Boolean(value);
};

export const isWrestlerAllowedByRosterRules = (
  wrestler,
  { onlyMainRoster = false, onlyNXT = false } = {}
) => {
  if (onlyNXT) return wrestler.brand === 'NXT';
  if (onlyMainRoster) return wrestler.brand === 'Raw' || wrestler.brand === 'SmackDown';
  return true;
};

export const getAssignedWrestlerIds = (
  factions = [],
  { excludedFactionId = null } = {}
) => {
  const assignedWrestlerIds = new Set();

  factions.forEach((faction) => {
    if (excludedFactionId && faction.id === excludedFactionId) return;

    getFactionWrestlerIds(faction).forEach((id) => {
      if (id) assignedWrestlerIds.add(id);
    });
  });

  return assignedWrestlerIds;
};

export const getRosterAvailableWrestlers = ({
  wrestlers = [],
  factions = [],
  includeAssigned = false,
  excludedFactionId = null,
  selectedWrestlerIds = [],
  onlyMainRoster = false,
  onlyNXT = false,
} = {}) => {
  const assignedWrestlerIds = getAssignedWrestlerIds(factions, {
    excludedFactionId,
  });
  const selectedIds = new Set(selectedWrestlerIds);

  return wrestlers
    .filter((wrestler) => isWrestlerActive(wrestler.active))
    .filter((wrestler) =>
      isWrestlerAllowedByRosterRules(wrestler, { onlyMainRoster, onlyNXT })
    )
    .filter((wrestler) => includeAssigned || !assignedWrestlerIds.has(wrestler.id))
    .filter((wrestler) => !selectedIds.has(wrestler.id));
};
